<template>
  <div>
    <HeaderView :title="$t('bank.title')" />
    <div class="view-page">
      <div class="add-card" @click="toBindCard()" v-if="!is_bind">
        <van-icon name="plus" />
        <span>{{ $t("bank.pushbtn") }}</span>
      </div>
      <div class="bank" v-else>
        <div class="info" style="margin-top: 10px;">
          <div>{{ $t('bank.bankname') }} : </div>
          <div class="row-content">{{ this.bankInfo.bankinfo }}</div>
          <div>{{ $t('bank.pername') }} : </div>
          <div class="row-content">{{ this.bankInfo.username }}</div>
          <div>{{ $t('bank.accountNo') }} : </div>
          <div class="row-content">{{ this.bankInfo.bankid }}</div>
          <div>{{ $t('bank.ifsc') }} : </div>
          <div class="row-content">{{ this.bankInfo.mobile }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from "@/components/Header/index.vue";
export default {
  name: "BankView",
  components: { HeaderView },
  data() {
    return {
      is_bind: false,
      bankInfo: {},
      userInfo: {},
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getUserBankInfo() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
            this.bankInfo = res.data.info;
          } else {
            this.is_bind = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    toBindCard() {
      if (!this.userInfo.name) {
        this.$router.push("setname");
        this.$toast(this.$t("setting.set_name_bank"));
        return true;
      } else if (!this.userInfo.paypassword) {
        this.$router.push("SetPayPassword");
        this.$toast(this.$t("setting.set_pwd_bank"));
        return true;
      } else {
        this.$router.push({ path: "/bankinfo" });
      }
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login" });
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  },
};
</script>
<style lang="scss" scoped>
.add-card {
  width: 90%;
  height: 10rem;
  background: #705b65;
  border-radius: 0.66667rem;
  text-align: center;
  line-height: 10rem;
  position: relative;
  margin: 1rem auto;
  font-size: 1.5rem;
  color: #fff;
}
.bank .info {
  margin-left: 20px;
  flex: 1;
  color: #000;
}
.bank .info .row-content{
  margin: 10px 0;
  line-height: 20px;
}
</style>
